import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-align-bottom"} maskId="square-filled-radius-0-stroke-1-IconLayoutAlignBottom"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM7 16V17H17V16H7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutAlignBottom;
